const initCountrySelector = (): void => {
  const countrySelectors = document.querySelectorAll('[data-country-selector]');
  if (!countrySelectors.length) return;
  countrySelectors.forEach((countrySelector: HTMLElement) => {
    countrySelector.addEventListener('change', (e) => {
      const el = e.target as HTMLSelectElement;
      window.location.href = el.value;
    })
  })
}

export {
  initCountrySelector
}